import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5bbce50c")

_pushScopeId("data-v-5bbce50c")
const _hoisted_1 = { class: "holiday-work-pattern-setting-container mb-32" }
const _hoisted_2 = { class: "main-container" }
const _hoisted_3 = { class: "font-bold text-2xl mb-8" }
const _hoisted_4 = { class: "work-pattern-setting-content" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { class: "max-input-work-pattern" }
const _hoisted_7 = { class: "flex items-center mt-4" }
const _hoisted_8 = { class: "max-input-work-pattern" }
const _hoisted_9 = { class: "flex items-center mt-4" }
const _hoisted_10 = { class: "select max-input-work-pattern" }
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = { class: "max-input-work-pattern" }
const _hoisted_13 = { class: "relative max-table-work-pattern" }
const _hoisted_14 = { class: "flex items-center justify-center" }
const _hoisted_15 = {
  key: 0,
  class: "flex justify-start"
}
const _hoisted_16 = { class: "select w-20 text-sm" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "mx-2 mt-3" }, "～", -1)
const _hoisted_18 = { class: "select w-20 text-sm" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "mt-4" }
const _hoisted_21 = { class: "max-input-work-pattern" }
const _hoisted_22 = { class: "relative max-table-work-pattern" }
const _hoisted_23 = { class: "flex items-center justify-center" }
const _hoisted_24 = {
  key: 0,
  class: "flex justify-start"
}
const _hoisted_25 = { class: "select w-20 text-sm" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "mx-2 mt-3" }, "～", -1)
const _hoisted_27 = { class: "select w-20 text-sm" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "action flex items-center mt-8 mb-4" }
const _hoisted_30 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-checkmark text-3xl" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-close text-3xl" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BackPreviousPage = _resolveComponent("BackPreviousPage")
  const _component_Label = _resolveComponent("Label")
  const _component_Input = _resolveComponent("Input")
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_Select = _resolveComponent("Select")
  const _component_InputTime = _resolveComponent("InputTime")
  const _component_Table = _resolveComponent("Table")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_BackPreviousPage, { onClick: _ctx.backToWorkPatternMasterList }, null, 8, ["onClick"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.t('workPatternMaster')) + ": " + _toDisplayString(_ctx.isUpdateAction ? _ctx.t('edit') : _ctx.t('signUp')), 1),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_Label, {
              mandatory: "",
              "text-label": _ctx.t('workPatternCode')
            }, null, 8, ["text-label"]),
            _createVNode(_component_Input, {
              modelValue: _ctx.apiPostData.shift_pattern_code,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.apiPostData.shift_pattern_code = $event)),
              validated: _ctx.validated,
              required: "",
              errors: _ctx.errors.shift_pattern_code,
              "onUpdate:errors": _cache[2] || (_cache[2] = ($event: any) => (_ctx.errors.shift_pattern_code = $event)),
              "error-server": _ctx.errorsServer.shift_pattern_code,
              placeholder: _ctx.t('pleaseEnter')
            }, null, 8, ["modelValue", "validated", "errors", "error-server", "placeholder"])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_Label, {
              mandatory: "",
              "text-label": _ctx.t('workPatternName')
            }, null, 8, ["text-label"]),
            _createVNode(_component_Input, {
              modelValue: _ctx.apiPostData.shift_pattern_name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.apiPostData.shift_pattern_name = $event)),
              validated: _ctx.validated,
              required: "",
              errors: _ctx.errors.shift_pattern_name,
              "onUpdate:errors": _cache[4] || (_cache[4] = ($event: any) => (_ctx.errors.shift_pattern_name = $event)),
              "error-server": _ctx.errorsServer.shift_pattern_name,
              placeholder: _ctx.t('pleaseEnter')
            }, null, 8, ["modelValue", "validated", "errors", "error-server", "placeholder"])
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_Label, {
              mandatory: "",
              "text-label": _ctx.t('ApplicableOra')
            }, null, 8, ["text-label"]),
            _createVNode(_component_MultiSelect, {
              options: _ctx.unitList,
              modelValue: _ctx.apiPostData.unit_ids,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.apiPostData.unit_ids = $event)),
              itemValue: "unit_id",
              itemText: "unit_name",
              placeholder: _ctx.t('pleaseEnterTheDepartment'),
              required: "",
              validated: _ctx.validated,
              errors: _ctx.errors.unit_ids,
              "onUpdate:errors": _cache[6] || (_cache[6] = ($event: any) => (_ctx.errors.unit_ids = $event)),
              "error-server": _ctx.errorsServer.unit_ids
            }, null, 8, ["options", "modelValue", "placeholder", "validated", "errors", "error-server"])
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_Label, {
              mandatory: "",
              "text-label": _ctx.t('workingPatternHours')
            }, null, 8, ["text-label"])
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode(_component_Table, {
              headers: _ctx.patternTableHeaders,
              data: _ctx.apiPostData.shift_pattern_times,
              class: "text-center"
            }, {
              function: _withId(({ index }) => [
                _createVNode("div", _hoisted_14, [
                  _withDirectives(_createVNode("span", {
                    onClick: ($event: any) => (
                      _ctx.addTimezoneDetail(
                        _ctx.apiPostData.shift_pattern_times[index - 1],
                        index
                      )
                    ),
                    class: "cp-icon-plus cursor-pointer font-size-32 text-light-blue border-1 border-color-grey-dc rounded-50 hover:opacity-75"
                  }, null, 8, ["onClick"]), [
                    [_vShow, 
                      _ctx.apiPostData.shift_pattern_times.length === index + 1
                    ]
                  ]),
                  _withDirectives(_createVNode("span", {
                    onClick: ($event: any) => (_ctx.removeTimezoneDetail(index)),
                    class: [
                      _ctx.apiPostData.shift_pattern_times.length > 2
                        ? 'cursor-pointer hover:opacity-75'
                        : 'cursor-default pointer-events-none'
                    , "cursor-pointer cp-icon-minus font-size-32 text-red-ff border-1 border-color-grey-dc rounded-50 hover:opacity-75"]
                  }, null, 10, ["onClick"]), [
                    [_vShow, 
                      _ctx.apiPostData.shift_pattern_times.length >= 2 &&
                      _ctx.apiPostData.shift_pattern_times.length !== index + 1
                    ]
                  ])
                ])
              ]),
              shiftPattern: _withId(({ index }) => [
                (index < _ctx.apiPostData.shift_pattern_times.length - 1)
                  ? (_openBlock(), _createBlock("div", _hoisted_15, [
                      _createVNode("div", _hoisted_16, [
                        _createVNode(_component_Select, {
                          "options-select": _ctx.optionsChoseTime,
                          "item-text": "text",
                          modelValue: 
                        _ctx.apiPostData.shift_pattern_times[index]
                          .start_time_day_type
                      ,
                          "onUpdate:modelValue": ($event: any) => (
                        _ctx.apiPostData.shift_pattern_times[index]
                          .start_time_day_type
                       = $event),
                          validated: _ctx.validated,
                          required: 
                        _ctx.apiPostData.shift_pattern_times[index].start_time
                      ,
                          errors: 
                        _ctx.errors[
                          'shift_pattern_times' + index + 'start_time_day_type'
                        ]
                      ,
                          "onUpdate:errors": ($event: any) => (
                        _ctx.errors[
                          'shift_pattern_times' + index + 'start_time_day_type'
                        ]
                       = $event)
                        }, null, 8, ["options-select", "modelValue", "onUpdate:modelValue", "validated", "required", "errors", "onUpdate:errors"])
                      ]),
                      _createVNode(_component_InputTime, {
                        class: "w-24 ml-2 text-sm",
                        modelValue: _ctx.apiPostData.shift_pattern_times[index].start_time,
                        "onUpdate:modelValue": ($event: any) => (_ctx.apiPostData.shift_pattern_times[index].start_time = $event),
                        errors: 
                      _ctx.errors['shift_pattern_times' + index + 'start_time']
                    ,
                        "onUpdate:errors": ($event: any) => (
                      _ctx.errors['shift_pattern_times' + index + 'start_time']
                     = $event),
                        validated: _ctx.validated,
                        required: 
                      _ctx.apiPostData.shift_pattern_times[index]
                        .start_time_day_type === 0 ||
                      _ctx.apiPostData.shift_pattern_times[index].start_time_day_type
                    ,
                        "error-server": 
                      _ctx.errorsServer[`shift_pattern_times.${index}.start_time`]
                    ,
                        placeholder: "--:--"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "errors", "onUpdate:errors", "validated", "required", "error-server"]),
                      _hoisted_17,
                      _createVNode("div", _hoisted_18, [
                        _createVNode(_component_Select, {
                          "options-select": _ctx.optionsChoseTime,
                          "item-text": "text",
                          modelValue: 
                        _ctx.apiPostData.shift_pattern_times[index].end_time_day_type
                      ,
                          "onUpdate:modelValue": ($event: any) => (
                        _ctx.apiPostData.shift_pattern_times[index].end_time_day_type
                       = $event),
                          errors: 
                        _ctx.errors[
                          'shift_pattern_times' + index + 'end_time_day_type'
                        ]
                      ,
                          "onUpdate:errors": ($event: any) => (
                        _ctx.errors[
                          'shift_pattern_times' + index + 'end_time_day_type'
                        ]
                       = $event),
                          validated: _ctx.validated,
                          required: 
                        _ctx.apiPostData.shift_pattern_times[index].end_time
                      
                        }, null, 8, ["options-select", "modelValue", "onUpdate:modelValue", "errors", "onUpdate:errors", "validated", "required"])
                      ]),
                      _createVNode(_component_InputTime, {
                        class: "w-24 ml-2 text-sm",
                        modelValue: _ctx.apiPostData.shift_pattern_times[index].end_time,
                        "onUpdate:modelValue": ($event: any) => (_ctx.apiPostData.shift_pattern_times[index].end_time = $event),
                        errors: 
                      _ctx.errors['shift_pattern_times' + index + 'end_time']
                    ,
                        "onUpdate:errors": ($event: any) => (
                      _ctx.errors['shift_pattern_times' + index + 'end_time']
                     = $event),
                        validated: _ctx.validated,
                        required: 
                      _ctx.apiPostData.shift_pattern_times[index]
                        .end_time_day_type === 0 ||
                      _ctx.apiPostData.shift_pattern_times[index].end_time_day_type
                    ,
                        "error-server": 
                      _ctx.errorsServer[`shift_pattern_times.${index}.end_time`]
                    ,
                        placeholder: "--:--"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "errors", "onUpdate:errors", "validated", "required", "error-server"])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_19))
              ]),
              _: 1
            }, 8, ["headers", "data"])
          ])
        ]),
        _createVNode("div", _hoisted_20, [
          _createVNode("div", _hoisted_21, [
            _createVNode(_component_Label, {
              "text-label": _ctx.t('breakTime')
            }, null, 8, ["text-label"])
          ]),
          _createVNode("div", {
            innerHTML: _ctx.t('desBreakTimeSetting'),
            class: "text-sm mb-1 mr-32"
          }, null, 8, ["innerHTML"]),
          _createVNode("div", _hoisted_22, [
            _createVNode(_component_Table, {
              headers: _ctx.patternBreakTableHeaders,
              data: _ctx.apiPostDataBreakTime.shift_pattern_times,
              class: "text-center"
            }, {
              function: _withId(({ index }) => [
                _createVNode("div", _hoisted_23, [
                  (
                      _ctx.apiPostDataBreakTime.shift_pattern_times.length ===
                      index + 1
                    )
                    ? (_openBlock(), _createBlock("span", {
                        key: 0,
                        onClick: ($event: any) => (
                      _ctx.addTimezoneDetailBreakTime(
                        _ctx.apiPostDataBreakTime.shift_pattern_times[index - 1],
                        index
                      )
                    ),
                        class: "cp-icon-plus cursor-pointer font-size-32 text-light-blue border-1 border-color-grey-dc rounded-50 hover:opacity-75"
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (
                      _ctx.apiPostDataBreakTime.shift_pattern_times.length >= 2 &&
                      _ctx.apiPostDataBreakTime.shift_pattern_times.length !==
                        index + 1
                    )
                    ? (_openBlock(), _createBlock("span", {
                        key: 1,
                        onClick: ($event: any) => (_ctx.removeTimezoneDetailBreakTime(index)),
                        class: "cursor-pointer cp-icon-minus font-size-32 text-red-ff border-1 border-color-grey-dc rounded-50 hover:opacity-75"
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              shiftPattern: _withId(({ index }) => [
                (
                    index < _ctx.apiPostDataBreakTime.shift_pattern_times.length - 1
                  )
                  ? (_openBlock(), _createBlock("div", _hoisted_24, [
                      _createVNode("div", _hoisted_25, [
                        _createVNode(_component_Select, {
                          "options-select": _ctx.optionsChoseTime,
                          "item-text": "text",
                          modelValue: 
                        _ctx.apiPostDataBreakTime.shift_pattern_times[index]
                          .start_time_day_type
                      ,
                          "onUpdate:modelValue": ($event: any) => (
                        _ctx.apiPostDataBreakTime.shift_pattern_times[index]
                          .start_time_day_type
                       = $event),
                          validated: _ctx.validated,
                          required: 
                        _ctx.apiPostDataBreakTime.shift_pattern_times[index]
                          .start_time ||
                        _ctx.apiPostDataBreakTime.shift_pattern_times[index]
                          .end_time_day_type
                      ,
                          errors: 
                        _ctx.errors[
                          'shift_pattern_times' +
                            _ctx.shiftPatternTimesLength +
                            index +
                            'start_time_day_type'
                        ]
                      ,
                          "onUpdate:errors": ($event: any) => (
                        _ctx.errors[
                          'shift_pattern_times' +
                            _ctx.shiftPatternTimesLength +
                            index +
                            'start_time_day_type'
                        ]
                       = $event)
                        }, null, 8, ["options-select", "modelValue", "onUpdate:modelValue", "validated", "required", "errors", "onUpdate:errors"])
                      ]),
                      _createVNode(_component_InputTime, {
                        class: "w-24 ml-2 text-sm",
                        modelValue: 
                      _ctx.apiPostDataBreakTime.shift_pattern_times[index].start_time
                    ,
                        "onUpdate:modelValue": ($event: any) => (
                      _ctx.apiPostDataBreakTime.shift_pattern_times[index].start_time
                     = $event),
                        errors: 
                      _ctx.errors[
                        'shift_pattern_times' +
                          _ctx.shiftPatternTimesLength +
                          index +
                          'start_time'
                      ]
                    ,
                        "onUpdate:errors": ($event: any) => (
                      _ctx.errors[
                        'shift_pattern_times' +
                          _ctx.shiftPatternTimesLength +
                          index +
                          'start_time'
                      ]
                     = $event),
                        validated: _ctx.validated,
                        required: 
                      _ctx.apiPostDataBreakTime.shift_pattern_times[index]
                        .start_time_day_type === 0 ||
                      _ctx.apiPostDataBreakTime.shift_pattern_times[index]
                        .end_time_day_type
                    ,
                        "error-server": 
                      _ctx.errorsServer[
                        `shift_pattern_times.${
                          _ctx.shiftPatternTimesLength + index
                        }.start_time`
                      ]
                    ,
                        placeholder: "--:--"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "errors", "onUpdate:errors", "validated", "required", "error-server"]),
                      _hoisted_26,
                      _createVNode("div", _hoisted_27, [
                        _createVNode(_component_Select, {
                          "options-select": _ctx.optionsChoseTime,
                          "item-text": "text",
                          modelValue: 
                        _ctx.apiPostDataBreakTime.shift_pattern_times[index]
                          .end_time_day_type
                      ,
                          "onUpdate:modelValue": ($event: any) => (
                        _ctx.apiPostDataBreakTime.shift_pattern_times[index]
                          .end_time_day_type
                       = $event),
                          errors: 
                        _ctx.errors[
                          'shift_pattern_times' +
                            _ctx.shiftPatternTimesLength +
                            index +
                            'end_time_day_type'
                        ]
                      ,
                          "onUpdate:errors": ($event: any) => (
                        _ctx.errors[
                          'shift_pattern_times' +
                            _ctx.shiftPatternTimesLength +
                            index +
                            'end_time_day_type'
                        ]
                       = $event),
                          validated: _ctx.validated,
                          required: 
                        _ctx.apiPostDataBreakTime.shift_pattern_times[index]
                          .end_time ||
                        _ctx.apiPostDataBreakTime.shift_pattern_times[index]
                          .start_time_day_type
                      
                        }, null, 8, ["options-select", "modelValue", "onUpdate:modelValue", "errors", "onUpdate:errors", "validated", "required"])
                      ]),
                      _createVNode(_component_InputTime, {
                        class: "w-24 ml-2 text-sm",
                        modelValue: 
                      _ctx.apiPostDataBreakTime.shift_pattern_times[index].end_time
                    ,
                        "onUpdate:modelValue": ($event: any) => (
                      _ctx.apiPostDataBreakTime.shift_pattern_times[index].end_time
                     = $event),
                        errors: 
                      _ctx.errors[
                        'shift_pattern_times' +
                          _ctx.shiftPatternTimesLength +
                          index +
                          'end_time'
                      ]
                    ,
                        "onUpdate:errors": ($event: any) => (
                      _ctx.errors[
                        'shift_pattern_times' +
                          _ctx.shiftPatternTimesLength +
                          index +
                          'end_time'
                      ]
                     = $event),
                        validated: _ctx.validated,
                        required: 
                      _ctx.apiPostDataBreakTime.shift_pattern_times[index]
                        .end_time_day_type ||
                      _ctx.apiPostDataBreakTime.shift_pattern_times[index]
                        .start_time_day_type
                    ,
                        "error-server": 
                      _ctx.errorsServer[
                        `shift_pattern_times.${
                          _ctx.shiftPatternTimesLength + index
                        }.end_time`
                      ]
                    ,
                        placeholder: "--:--"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "errors", "onUpdate:errors", "validated", "required", "error-server"])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_28))
              ]),
              _: 1
            }, 8, ["headers", "data"])
          ])
        ]),
        _createVNode("div", _hoisted_29, [
          _createVNode(_component_Button, {
            onClick: _ctx.handleRegisterOrUpdate,
            class: "h-12 text-base",
            disabled: _ctx.isDisableSubmit()
          }, {
            default: _withId(() => [
              _hoisted_30,
              _createTextVNode(_toDisplayString(_ctx.isUpdateAction ? _ctx.t('save') : _ctx.t('toRegister')), 1)
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]),
          _createVNode(_component_Button, {
            onClick: _ctx.backToWorkPatternMasterList,
            class: "cancel h-12 text-base ml-4",
            variant: "outline-primary"
          }, {
            default: _withId(() => [
              _hoisted_31,
              _createTextVNode(" " + _toDisplayString(_ctx.t('cancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ]))
})